import { render, staticRenderFns } from "./ChangGuanD.vue?vue&type=template&id=710fee84&scoped=true"
import script from "./ChangGuanD.vue?vue&type=script&lang=js"
export * from "./ChangGuanD.vue?vue&type=script&lang=js"
import style0 from "./ChangGuanD.vue?vue&type=style&index=0&id=710fee84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710fee84",
  null
  
)

export default component.exports